import {Component, Input, } from '@angular/core';
import { EventComposite, PermissionNames, SecurityPermissionsDto, VisibleToEnum, } from 'webcommon/shared';
import { ApBaseComponent, } from 'webcommon/core-ui';
import { FilterCommonFormControls } from '../models/FilterFormControls';
import { FormGroup } from '@angular/forms';


@Component({
  selector: 'fc-filter-common',
  styleUrls: ['./fc-filter-common.component.less'],
  templateUrl: 'fc-filter-common.component.html',
})
export class FcFilterModalComponent extends ApBaseComponent {

  @Input() baseId: string;
  @Input() hideDefault: boolean;
  @Input() filterPermission$: EventComposite<SecurityPermissionsDto | null, PermissionNames | null>;
  @Input() filterCommonFormGroup: FormGroup<FilterCommonFormControls>;

  visitToEnum = VisibleToEnum;

}
